module.exports = __webpack_public_path__ + "media/images/flags/16/Ukraine-55fcf1beb14f2ba153c2328184951132.png";